module.exports = __webpack_public_path__ + "img/triple_token.triple.5cd1e3d.png";